module.exports = require("crypto-js/hmac-sha1");